import * as config from "./../config/config";
import api from "./interceptor";

// =========================
// CAISSES
// =========================

export async function getCaisses(agenceId) {
  try {
    const response = await api.get(
      config.REACT_APP_ENDPOINT_GET_CAISSE,
      {
        params: {
          agence_id: agenceId,
        },
      }
    );
    console.log("response", response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function createCaisse(payload) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_CREATE_CAISSE,
      payload
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getDashboard(caisseId, { annee, mois } = {}) {
  try {
    const response = await api.get(
      `${config.REACT_APP_ENDPOINT_DASHBOARD_CAISSE}/${caisseId}/dashboard`,
      {
        params: {
          annee,
          mois,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

// =========================
// DEPARTEMENTS
// =========================

export async function getDepartements(agenceId) {
  try {
    const response = await api.get(
      config.REACT_APP_ENDPOINT_DEPARTEMENT_CAISSE,
      {
        params: {
          agence_id: agenceId,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function createDepartement(payload) {
  try {
    console.log(payload);
    const response = await api.post(
      config.REACT_APP_ENDPOINT_CREATE_DEPARTEMENT_CAISSE,
      payload
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateDepartement(id, payload) {
  try {
    const response = await api.put(
      `${config.REACT_APP_ENDPOINT_UPDATE_DEPARTEMENT_CAISSE}/${id}`,
      payload
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteDepartement(id) {
  try {
    const response = await api.delete(
      `${config.REACT_APP_ENDPOINT_DELETE_DEPARTEMENT_CAISSE}/${id}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

// =========================
// MODES DE PAIEMENT
// =========================

export async function getModesPaiement() {
  try {
    const response = await api.get(
      config.REACT_APP_ENDPOINT_MODES_PAIEMENT
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}


// =========================
// MOUVEMENTS
// =========================

export async function getMouvements(params) {
  try {
    console.log(config.REACT_APP_ENDPOINT_GET_MOUVEMENTS_CAISSE);
    const response = await api.get(
      config.REACT_APP_ENDPOINT_GET_MOUVEMENTS_CAISSE,
      {
        params,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function createMouvement(data) {
  const response = await api.post(
    config.REACT_APP_ENDPOINT_CREATE_MOUVEMENT_CAISSE,
    data
  );

  return response.data;
}

export async function addpj(id,data) {
  const response = await api.post(
    config.REACT_APP_ENDPOINT_ADDPJ_MOUVEMENT_CAISSE + id,
    data
  );

  return response.data;
}

export async function deleteMouvement(id) {
  try {
    const response = await api.delete(
      `${config.REACT_APP_ENDPOINT_DELETE_MOUVEMENT_CAISSE}/${id}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function exportMouvements(params) {
  try {
    const response = await api.get(
      config.REACT_APP_ENDPOINT_EXPORT_MOUVEMENT_CAISSE,
      {
        params,
        responseType: "blob", // important : la réponse est un fichier binaire (zip), pas du JSON
      }
    );

    return response; // on renvoie la réponse complète (headers + data), pas juste response.data
  } catch (error) {
    throw error;
  }
}

export async function exportMouvementPj(mouvementId) {
  try {
    const response = await api.get(
      `${config.REACT_APP_ENDPOINT_EXPORT_MOUVEMENT_PJ}/${mouvementId}/photos/export`,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export const getCategories = async (departementId) => {
  try {
    const response = await api.get(
      `${config.REACT_APP_ENDPOINT_DEPARTEMENT_CAISSE}/${departementId}/categories`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCategorie = async (departementId, payload) => {
  try {
    const response = await api.post(
      `${config.REACT_APP_ENDPOINT_DEPARTEMENT_CAISSE}/${departementId}/categories`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCategorie = async (id) => {
  try {
    const response = await api.delete(`${config.REACT_APP_ENDPOINT_CATEGORIE_CAISSE}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};